import { faChevronDown, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { Component } from 'react';
import { ButtonGroup, Button, Well } from 'react-bootstrap';

const steps = [
	{
		id: 1,
		text: 'MoveLessons_SelectChild'
	},
	{
		id: 2,
		text: 'MoveLessons_SelectTargetWeeklyProgram'
	},
	{
		id: 3,
		text: 'MoveLessons_SelectLessonDates'
	}
];

const Navigation = ({ currentStep, onGoToStep, onPreviousStep, t, status }) => {

	const renderButton = (currentStep, step) => {
		const isCurrentStep = currentStep === step.id;
		const icon = <FontAwesomeIcon icon={isCurrentStep ? faChevronDown : faChevronRight} />;
		const props = isCurrentStep ? { bsStyle: 'primary' } : {};
		return (
			<Button key={step.id} {...props} href='#' disabled={true} style={{ whiteSpace: 'normal' }}>
				<strong>{`${t(step.text)} `}</strong>
				{icon}
			</Button>
		);
	};

	const isVertical = window.innerWidth < 1320;

	return (
		<div>
			<ButtonGroup block vertical={isVertical} justified={!isVertical} className='mb-1'>
				{steps.map(step => renderButton(currentStep, step))}
			</ButtonGroup>
			<div>
				{
					status &&
					<Well bsSize='small'>{status}</Well>
				}
				{
					currentStep === 1 ||
					<Button onClick={() => onPreviousStep()} className='mb-1'>
						{t('Common_PreviousStep')}
					</Button>
				}
				
			</div>
		</div>
	);
};

export default Navigation;